module.exports = __webpack_public_path__ + "img/japan-flag.1e4691a2.png";